import React, { useState, useEffect } from "react";
import { Modal, Button } from "react-bootstrap";
import Select from "react-select";
import { ApiUrl } from "../../../ApiUrl";
const EditTransportModal = ({
  show,
  handleClose,
  studentData,
  transportDetails,
  routes,
}) => {
  const [selectedRoute, setSelectedRoute] = useState(null);
  const [selectedPickup, setSelectedPickup] = useState("");
  const [amount, setAmount] = useState("");
  const [transportAvailed, setTransportAvailed] = useState(false);
  const [selectedMonths, setSelectedMonths] = useState([]);
  const [route, setRoute] = useState([]);
  const [months, setMonths] = useState([]);
  const [pickupPoints, setPickupPoints] = useState([]);
  const [selectedPickups, setSelectedPickups] = useState(null);
  const [amounts, setAmounts] = useState("");
  const [monthStatus, setMonthStatus] = useState([]);
  const [routeOptions, setRouteOptions] = useState([]);

  const handleClear = () => {
    // Reset transport checkbox
    setTransportAvailed(false);

    // Reset months (uncheck all and enable them again)
    setMonthStatus((prev) =>
      prev.map((month) => ({
        ...month,
        checked: false,
        disabled: false,
      }))
    );

    // Reset dropdowns
    setSelectedRoute(null);
    setSelectedPickup(null);

    // Reset amount
    setAmount("");
  };

  useEffect(() => {
    const fetchRoutes = async () => {
      const branchId = localStorage.getItem("branchId");
      const orgId = localStorage.getItem("orgId");
      if (!branchId || !orgId)
        return console.error("Missing branchId or orgId");
      try {
        const response = await fetch(
          `${ApiUrl.apiurl}Transport/routemasterlist/${orgId}/${branchId}/`
        );
        if (!response.ok) throw new Error("Failed to fetch routes");
        const data = await response.json();
        const formattedRoutes = data.map((route) => ({
          value: route.id,
          label: route.transport_name,
        }));
        setRouteOptions(formattedRoutes);
        if (transportDetails?.routeId) {
          const matchedRoute = formattedRoutes.find(
            (r) => r.value === transportDetails.routeId
          );
          setSelectedRoute(matchedRoute || null);
        }
      } catch (error) {
        console.error("Error fetching routes:", error);
      }
    };
    if (show) fetchRoutes();
  }, [show, transportDetails]);
  useEffect(() => {
    if (!selectedRoute) return;
    const fetchPickupPoints = async () => {
      try {
        const response = await fetch(
          `${ApiUrl.apiurl}Transport/GetAllPickupPointBasedOnRoute/${selectedRoute.value}`
        );
        if (!response.ok) throw new Error("Failed to fetch pickup points");
        const data = await response.json();
        console.log("Pickup points response:", data); // Debug log
        const formattedPickupPoints = data.data.map((point) => ({
          value: point.routeDetailsId,
          label: point.pickup_point_name,
          amount: point.amount,
        }));
        setPickupPoints(formattedPickupPoints);
        
        // Try to match the pickup point from transportDetails
        if (transportDetails?.pickup_point_name || transportDetails?.pickuppointId) {
          const matchedPickup = formattedPickupPoints.find(
            (p) => p.label === transportDetails.pickup_point_name || p.value === transportDetails.pickuppointId
          );
          if (matchedPickup) {
            console.log("Matched pickup:", matchedPickup); // Debug log
            setSelectedPickup(matchedPickup);
            if (matchedPickup.amount) {
              setAmount(matchedPickup.amount);
            }
          } else {
            console.log("No matching pickup point found for:", transportDetails.pickup_point_name); // Debug log
            setSelectedPickup(null);
          }
        }
      } catch (error) {
        console.error("Error fetching pickup points:", error);
      }
    };
    fetchPickupPoints();
  }, [selectedRoute, transportDetails]);
  useEffect(() => {
    if (transportDetails) {
      const matchedRoute = routes.find(
        (route) => route.value === transportDetails.routeId
      );
      setSelectedRoute(matchedRoute || null);
      setAmount(transportDetails.amount || "");
      setTransportAvailed(transportDetails.transport_avail || false);
      if (transportDetails.transport_avail) {
        const monthsFromApi = (transportDetails.choice_month || []).map(
          (month, index) => {
            // If period_id is null, use the month's period_id from API response, 
            // or use index + 1 as fallback (1-12 for months)
            // or try to extract from the month name
            let monthId = month.period_id;
            
            if (!monthId) {
              // Try to get ID from other possible field names
              monthId = month.id || month.monthId || month.month_id;
            }
            
            if (!monthId) {
              // As last resort, use index + 1 (assuming months are 1-12)
              monthId = index + 1;
            }
            
            const monthName = month.period_name || month.name || month.month_name;
            console.log(`Month ${index}:`, month, "Final ID:", monthId, "Name:", monthName); // Debug log
            
            return {
              id: monthId,
              name: monthName,
              flag: month.flag,
              checked: true,
              disabled: month.flag === "No",
            };
          }
        );
        console.log("Final monthStatus (availed):", monthsFromApi); // Debug log
        setMonthStatus(monthsFromApi);
      } else {
        setMonthStatus(
          (transportDetails.choice_month || []).map((month, index) => {
            let monthId = month.period_id || month.id || month.monthId || month.month_id;
            if (!monthId) {
              monthId = index + 1;
            }
            return {
              id: monthId,
              name: month.period_name || month.name || month.month_name,
              flag: month.flag,
              checked: false,
              disabled: false,
            };
          })
        );
        setSelectedRoute(null);
        setSelectedPickup(null);
        setAmount("");
      }
    }
  }, [transportDetails, routes]);
  const handleMonthToggle = (id) => {
    setMonthStatus((prev) =>
      prev.map((month) =>
        month.id === id && !month.disabled
          ? { ...month, checked: !month.checked }
          : month
      )
    );
  };
  // const handleSaveChanges = async () => {
  //   if (!studentData?.student_id) {
  //     alert("Student ID is missing!");
  //     return;
  //   }
  //   const selectedMonthIds = monthStatus
  //     .filter((month) => month.checked)
  //     .map((month) => month.id);
  //   if (!selectedRoute || !selectedPickup || selectedMonthIds.length === 0) {
  //     alert("Please select Route, Pickup Point, and at least one Month.");
  //     return;
  //   }
  //   const payload = {
  //     created_by: 1,
  //     student_id: studentData.student_id,
  //     transport_avail: transportAvailed,
  //     period_month: selectedMonthIds,
  //     routeId: selectedRoute?.value,
  //     pickuppointId: selectedPickup?.value,
  //     amount: parseFloat(amount),
  //   };
  //   try {
  //     const response = await fetch(
  //       `${ApiUrl.apiurl}Transport/UpdateStudentTransport/`,
  //       {
  //         method: "PUT",
  //         headers: { "Content-Type": "application/json" },
  //         body: JSON.stringify(payload),
  //       }
  //     );
  //     if (!response.ok) throw new Error("Failed to update transport details");
  //     alert("Transport details updated successfully!");
  //     handleClose();
  //   } catch (error) {
  //     console.error("Error updating transport:", error);
  //     alert("Failed to update transport details. Please try again.");
  //   }
  // };

  const handleSaveChanges = async () => {
    if (!studentData?.student_id) {
      alert("Student ID is missing!");
      return;
    }

    const userId = sessionStorage.getItem("userId"); // Fetch userId from session storage
    if (!userId) {
      alert("User ID is missing in session!");
      return;
    }

    const selectedMonthIds = monthStatus
      .filter((month) => month.checked)
      .map((month) => month.id)
      .filter((id) => id !== null && id !== undefined); // Filter out null/undefined IDs

    console.log("Selected Months:", monthStatus.filter((month) => month.checked)); // Debug log
    console.log("Selected Month IDs:", selectedMonthIds); // Debug log

    // Validation: If transport is availed, require at least one month
    if (transportAvailed && selectedMonthIds.length === 0) {
      alert("Please choose at least one valid period month to avail transport.");
      return;
    }

    // Build payload - only include fields with values
    const payload = {
      created_by: userId,
      student_id: studentData.student_id,
      transport_avail: transportAvailed,
    };

    // When transport is availed, include required fields
    if (transportAvailed) {
      // Include months (already validated above)
      payload.period_month = selectedMonthIds;
      
      // Require route and pickup if availing transport
      if (!selectedRoute?.value) {
        alert("Please select a route.");
        return;
      }
      payload.routeId = selectedRoute.value;
      
      if (!selectedPickup?.value) {
        alert("Please select a pickup point.");
        return;
      }
      payload.pickuppointId = selectedPickup.value;
    }

    // Add amount if it's a valid number
    const parsedAmount = parseFloat(amount);
    if (!isNaN(parsedAmount) && parsedAmount > 0) {
      payload.amount = parsedAmount;
    } else {
      payload.amount = 0;
    }

    console.log("Sending payload:", payload); // Debug log

    try {
      const response = await fetch(
        `${ApiUrl.apiurl}Transport/UpdateStudentTransport/`,
        {
          method: "PUT",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(payload),
        }
      );

      const responseData = await response.json();
      console.log("Response:", responseData); // Debug log

      if (!response.ok) {
        throw new Error(responseData?.message || "Failed to update transport details");
      }

      alert("Transport details updated successfully!");
      handleClose();
      window.location.reload();
    } catch (error) {
      console.error("Error updating transport:", error);
      alert("Failed to update transport details: " + error.message);
    }
  };

  const currentMonth = new Date().getMonth() + 1;
  if (!studentData) {
    console.log("No Student Data Found");
    return null;
  }


  const handleTransportAvailedChange = () => {
    if (transportAvailed) {
      // User is trying to uncheck
      const hasNoFlag = monthStatus.some((month) => month.flag === "No");

      if (hasNoFlag) {
        alert(
          "Transport can't be unavailed as one or more months are locked (flag: No)."
        );
        return;
      }

      // All flags are "Yes", uncheck all months
      const updatedMonths = monthStatus.map((month) => ({
        ...month,
        checked: false,
      }));
      setMonthStatus(updatedMonths);
      setSelectedRoute(null);
      setSelectedPickup(null);
      setAmount("");
    }

    setTransportAvailed(!transportAvailed);
  };
  
  
  return (
    <Modal show={show} onHide={handleClose} size="lg" centered>
      <Modal.Header closeButton>
        <Modal.Title>Edit Transport Details</Modal.Title>
      </Modal.Header>
      <Modal.Body style={{ maxHeight: "75vh", overflowY: "auto" }}>
        {/* Search Section */}
        <div className="container-fluid">
          <div className="d-flex flex-wrap gap-2 mb-3">
            <button
              type="button"
              className="btn btn-secondary me-2"
              onClick={handleClear}
            >
              Clear
            </button>
            <Button
              type="button"
              className="btn btn-primary"
              onClick={handleSaveChanges}
            >
              Save
            </Button>
            <button
              onClick={handleClose}
              type="button"
              className="btn btn-danger"
              data-bs-dismiss="modal"
            >
              Close
            </button>
          </div>
          {/* Student Info */}
          <div className="border p-3 rounded">
            <div className="row g-2">
              <div className="col-md-4">
                <label className="form-label">Student Name</label>
                <input
                  type="text"
                  className="form-control detail"
                  value={studentData.studentname || ""}
                  readOnly
                  disabled
                />
              </div>
              <div className="col-md-4">
                <label className="form-label">Admission No</label>
                <input
                  type="text"
                  className="form-control detail"
                  value={transportDetails?.admission_no || ""}
                  readOnly
                  disabled
                />
              </div>
              <div className="col-md-4">
                <label className="form-label">Student Barcode</label>
                <input
                  type="text"
                  className="form-control detail"
                  value={studentData.barcode || ""}
                  readOnly
                  disabled
                />
              </div>
            </div>
            <div className="row g-2 mt-2">
              <div className="col-md-4">
                <label className="form-label">Father Name</label>
                <input
                  type="text"
                  className="form-control detail"
                  value={transportDetails?.fathername || ""}
                  readOnly
                  disabled
                />
              </div>
              <div className="col-md-4">
                <label className="form-label">Mother Name</label>
                <input
                  type="text"
                  className="form-control detail"
                  value={transportDetails?.mothername || ""}
                  readOnly
                  disabled
                />
              </div>
              <div className="col-md-4">
                <label className="form-label">School Admission No</label>
                <input
                  type="text"
                  className="form-control detail"
                  value={studentData.school_admission_no || ""}
                  readOnly
                  disabled
                />
              </div>
            </div>
          </div>
          {/* Transport Details */}
          <div className="border p-3 rounded mt-3">
            <fieldset className="p-3">
              <legend className="fw-bold">Student Transport Details</legend>
              <div className="d-flex justify-content-end">
                <label className="form-check-label fw-bold">
                  <input
                    type="checkbox"
                    className="form-check-input me-2"
                    checked={transportAvailed}
                    // onChange={(e) => setTransportAvailed(e.target.checked)}
                    onChange={handleTransportAvailedChange}
                  />
                  Transport Availed
                </label>
              </div>
              {/* Months Selection */}
              <div className="row g-2 mt-3">
                {monthStatus.map((month) => (
                  <div key={month.id} className="col-6 col-md-3">
                    <label className="form-check-label">
                      <input
                        type="checkbox"
                        className="form-check-input me-2"
                        checked={month.checked}
                        onChange={() => handleMonthToggle(month.id)}
                        disabled={month.disabled}
                      />
                      {month.name}
                    </label>
                  </div>
                ))}
              </div>
              {/* Transport Selection */}
              <div className="row g-2 mt-3">
                <div className="col-md-4">
                  <label className="form-label fw-bold">Route</label>
                  <Select
                    options={routeOptions}
                    className="detail"
                    value={selectedRoute}
                    onChange={(option) => {
                      setSelectedRoute(option);
                      setSelectedPickup(null);
                      setAmount("");
                    }}
                    isDisabled={!transportAvailed}
                    placeholder="Select a route"
                  />
                </div>
                <div className="col-md-4">
                  <label className="form-label fw-bold">Pickup Point</label>
                  <Select
                    options={pickupPoints}
                    className="detail"
                    value={selectedPickup}
                    onChange={(option) => {
                      setSelectedPickup(option);
                      setAmount(option.amount);
                    }}
                    isDisabled={!selectedRoute || !transportAvailed}
                    placeholder="Select a pickup point"
                  />
                </div>
                <div className="col-md-4">
                  <label className="form-label fw-bold">Amount</label>
                  <input
                    type="text"
                    className="form-control detail"
                    value={amount}
                    readOnly
                    disabled
                  />
                </div>
              </div>
            </fieldset>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
};
export default EditTransportModal;
